/* Storefront bridge — plain readable code, no encoding, no per-visitor logic.
   The theme's own cart drawer is the single basket. "Buy it now"/"Add to cart"
   add to the native cart and open the drawer; every native checkout button is
   replaced by a static link to the store that processes the payment, built from
   the variant ids mapped on this storefront (metafield custom.checkout_variant_id). */
(function () {
  var CHECKOUT_DOMAIN = "mixnuw-a1.myshopify.com";
  var lastUrl = "https://" + CHECKOUT_DOMAIN + "/cart";
  var lastCartData = null;

  /* ---- attribution ------------------------------------------------------
     Everything that arrives on the landing URL is captured on the first page
     view, kept for the session and appended to every link that leaves the
     storefront: as real query params (landing_site + client-side pixels),
     mirrored in attributes[...] (stored on the order) and as ref= (Shopify
     Conversion Summary). No fixed allowlist: only a short blocklist of
     Shopify/theme internals, so new click ids keep working automatically. */

  var ATTR_KEY = "tcs_attr";
  var ATTR_MAX_KEYS = 25;
  var BLOCKED = [
    "op", "i", "t", "sxfb", "r", "key", "signature", "preview_theme_id",
    "preview_key", "_ab", "_fd", "_sc", "section_id", "sections", "variant",
    "q", "page", "sort_by", "filter", "discount", "ref"
  ];

  function blocked(key) {
    if (!key || key.length > 60) return true;
    if (key.indexOf("attributes[") === 0) return true;
    for (var i = 0; i < BLOCKED.length; i++) if (BLOCKED[i] === key) return true;
    return false;
  }

  function storedAttribution() {
    try {
      var raw = sessionStorage.getItem(ATTR_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) { return {}; }
  }

  function captureAttribution() {
    var out = storedAttribution();
    try {
      var q = new URLSearchParams(window.location.search);
      q.forEach(function (value, key) {
        if (!value || blocked(key)) return;
        if (Object.keys(out).length >= ATTR_MAX_KEYS && !out[key]) return;
        out[key] = String(value).slice(0, 200);
      });
      var incomingRef = q.get("ref");
      if (incomingRef) out["ref"] = String(incomingRef).slice(0, 200);
      sessionStorage.setItem(ATTR_KEY, JSON.stringify(out));
    } catch (e) {}
    return out;
  }

  var ATTRIBUTION = captureAttribution();

  function refValue(a) {
    if (a["ref"]) return a["ref"];
    var parts = [];
    var order = ["utm_source", "utm_medium", "utm_campaign"];
    for (var i = 0; i < order.length; i++) if (a[order[i]]) parts.push(a[order[i]]);
    if (parts.length) return parts.join("-").slice(0, 200);
    if (a["gclid"] || a["wbraid"] || a["gbraid"]) return "google";
    if (a["fbclid"]) return "facebook";
    if (a["ttclid"]) return "tiktok";
    if (a["msclkid"]) return "bing";
    if (a["epik"]) return "pinterest";
    if (a["sccid"]) return "snapchat";
    return "";
  }

  function decorate(href) {
    try {
      var url = new URL(href, window.location.href);
      for (var key in ATTRIBUTION) {
        if (!Object.prototype.hasOwnProperty.call(ATTRIBUTION, key)) continue;
        if (key === "ref") continue;
        var value = ATTRIBUTION[key];
        if (!value) continue;
        url.searchParams.set(key, value);
        url.searchParams.set("attributes[" + key + "]", value);
      }
      var ref = refValue(ATTRIBUTION);
      if (ref) {
        url.searchParams.set("ref", ref);
        url.searchParams.set("attributes[ref]", ref);
        url.searchParams.set("attributes[tcs_ref]", ref);
      }
      return url.toString();
    } catch (e) { return href; }
  }

  /* Static links rendered by Liquid also get the parameters, so the visible
     destination in the HTML carries the campaign data. */
  function decorateStaticLinks(root) {
    var nodes = [];
    findDeep(root || document, "a.tcs-checkout-link, a.tcs-cart__checkout", nodes);
    nodes.forEach(function (node) {
      var href = node.getAttribute("href") || "";
      if (!href || href.indexOf("http") !== 0) return;
      if (node.getAttribute("data-tcs-attr") === "1") return;
      node.setAttribute("href", decorate(href));
      node.setAttribute("data-tcs-attr", "1");
    });
  }


  function fetchCartData() {
    return fetch("/?sections=tcs-cart-data", { credentials: "same-origin", cache: "no-store" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (payload) {
        if (!payload) return null;
        var html = payload["tcs-cart-data"];
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var node = doc.getElementById("tcs-cart-data");
        if (!node) return null;
        try { return JSON.parse(node.textContent || "{}"); } catch (e) { return null; }
      })
      .catch(function () { return null; });
  }

  function urlFromData(data) {
    var parts = [];
    if (data && data.items) {
      for (var i = 0; i < data.items.length; i++) {
        var line = data.items[i];
        if (line.checkoutId) parts.push(line.checkoutId + ":" + line.qty);
      }
    }
    if (!parts.length) return decorate("https://" + CHECKOUT_DOMAIN + "/cart");
    return decorate("https://" + CHECKOUT_DOMAIN + "/cart/" + parts.join(","));
  }

  /* ---- native checkout buttons -> static link (visible destination) ------ */

  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href^="/checkout?"]',
    ".cart__checkout-button"
  ].join(",");

  /* The theme drawer is a web component: also walk shadow roots. */
  function findDeep(root, selector, out) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) out.push(nodes[i]);
    var all = root.querySelectorAll("*");
    for (var j = 0; j < all.length; j++) {
      if (all[j].shadowRoot) findDeep(all[j].shadowRoot, selector, out);
    }
  }

  function patchAll(root) {
    var nodes = [];
    findDeep(root, CHECKOUT_SELECTOR, nodes);
    nodes.forEach(function (node) {
      if (node.hasAttribute("data-tcs-native")) return;
      var existing = node.parentNode && node.parentNode.querySelector("a.tcs-cart__checkout[data-tcs-native]");
      if (!existing) {
        existing = document.createElement("a");
        existing.className = "tcs-cart__checkout " + (node.className || "");
        existing.setAttribute("rel", "noreferrer");
        existing.setAttribute("referrerpolicy", "no-referrer");
        existing.setAttribute("data-tcs-native", "");
        existing.textContent = node.textContent && node.textContent.trim() ? node.textContent.trim() : "Checkout";
        if (node.parentNode) node.parentNode.insertBefore(existing, node);
      }
      existing.setAttribute("href", lastUrl);
      node.style.display = "none";
      node.setAttribute("data-tcs-native", "");
    });
  }

  function refresh() {
    return fetchCartData().then(function (data) {
      if (data) lastCartData = data;
      patchAll(document);
      decorateStaticLinks(document);
      return lastUrl;
    });
  }

  /* ---- add to the native cart, open the theme drawer --------------------- */

  function findFirstDeep(selector) {
    var out = [];
    findDeep(document, selector, out);
    return out.length ? out[0] : null;
  }

  function openDrawer() {
    var drawer = document.getElementById("cart-drawer");
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return;
    }
    var toggle = findFirstDeep('button[aria-label*="Cart" i], button[aria-label*="cart" i]');
    if (toggle) toggle.click();
  }

  function addNative(variantId, qty) {
    var sectionIds = [];
    var comps = document.querySelectorAll("cart-items-component");
    for (var i = 0; i < comps.length; i++) {
      var sid = comps[i].getAttribute("data-section-id");
      if (sid) sectionIds.push(sid);
    }
    var body = { items: [{ id: Number(variantId), quantity: qty || 1 }] };
    if (sectionIds.length) body.sections = sectionIds.join(",");
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (response) {
        if (!response) return;
        /* Evento nativo do tema: atualiza a gaveta e o contador do header. */
        document.dispatchEvent(new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: response,
            sourceId: "tcs-bridge",
            data: { source: "tcs-bridge", sections: response.sections, variantId: String(variantId) }
          }
        }));
        refresh();
        /* Abre a gaveta imediatamente após o item ser contabilizado. */
        openDrawer();
        window.setTimeout(refresh, 1500);
      }).catch(function () { /* ignore */ });
  }

  /* Prefer the theme's own add-to-cart button: it adds and opens the drawer
     with fresh content all by itself. */
  function nativeAddButton() {
    var out = [];
    findDeep(document, 'button[name="add"], form[action*="/cart/add"] [type="submit"], .add-to-cart-button, [class*="sticky-add-to-cart"] button', out);
    for (var i = 0; i < out.length; i++) {
      if (!out[i].hasAttribute("data-tcs-add")) return out[i];
    }
    return null;
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var bridgeButton = target.closest("[data-tcs-add], a.tcs-checkout-link");
    if (!bridgeButton) {
      var nativeButton = target.closest('button[name="add"], form[action*="/cart/add"] [type="submit"], .add-to-cart-button, [class*="sticky-add-to-cart"] button');
      if (nativeButton) {
        window.setTimeout(function () {
          refresh().then(openDrawer);
        }, 900);
      }
      return;
    }
    if (bridgeButton.hasAttribute("data-tcs-native")) return;

    var variantId = bridgeButton.getAttribute("data-variant-id");
    if (variantId) {
      event.preventDefault();
      addNative(variantId, 1);
      return;
    }
    var nativeButton = nativeAddButton();
    if (nativeButton) {
      event.preventDefault();
      nativeButton.click();
      window.setTimeout(refresh, 1500);
      return;
    }
    /* Sem id de variante nem botão nativo: o link estático segue viagem. */
  }, true);

  /* Every path to "finish the purchase" (drawer, cart page, cart icon flows,
     third-party cart apps, forms) goes through one function that reads the
     live cart at click time. The link never leaves with an empty cart: if no
     mapped item is found, the buyer stays on the native checkout. */
  var leaving = false;
  function goCheckout(fallbackHref) {
    if (leaving) return;
    leaving = true;
    var navigated = false;
    /* Navegação sem enviar a página de origem no cabeçalho Referer:
       âncora temporária com rel="noreferrer" + referrerPolicy="no-referrer". */
    var done = function (url) {
      if (navigated) return;
      navigated = true;
      var a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("data-tcs-navigation", "");
      a.setAttribute("rel", "noreferrer");
      a.setAttribute("referrerpolicy", "no-referrer");
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      window.setTimeout(function () { if (a.parentNode) a.parentNode.removeChild(a); }, 1000);
    };
    /* Se a leitura do carrinho falhar, o destino é o próprio link do botão
       (já renderizado com os itens) — nunca o checkout da vitrine enquanto
       houver um link válido para a loja de checkout. */
    var fallback = function () {
      if (lastCartData && lastCartData.items && lastCartData.items.length) {
        var cachedUrl = urlFromData(lastCartData);
        if (cachedUrl.indexOf(CHECKOUT_DOMAIN + "/cart/") > -1) return cachedUrl;
      }
      if (fallbackHref && fallbackHref.indexOf(CHECKOUT_DOMAIN + "/cart/") > -1) return fallbackHref;
      if (lastUrl.indexOf("/cart/") > -1) return lastUrl;
      return "/checkout?sxfb=1";
    };
    var safety = window.setTimeout(function () { done(fallback()); }, 4000);
    fetchCartData().then(function (data) {
      window.clearTimeout(safety);
      if (data) lastCartData = data;
      var url = data ? urlFromData(data) : lastUrl;
      if (url.indexOf("/cart/") === -1) url = fallback();
      lastUrl = url;
      done(url);
    }, function () {
      window.clearTimeout(safety);
      done(fallback());
    });
  }

  var CHECKOUT_ANY = CHECKOUT_SELECTOR + ', a.tcs-cart__checkout, a[href*="' + CHECKOUT_DOMAIN + '/cart"], [href$="/checkout"], [data-checkout], .checkout-button, [class*="checkout-btn"], [class*="checkout_button"]';

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest("a.tcs-checkout-link")) return;
    var el = target.closest(CHECKOUT_ANY);
    if (!el) return;
    if (el.hasAttribute("data-tcs-navigation")) return;
    var href = el.tagName === "A" ? el.getAttribute("href") || "" : "";
    /* Preserve normal open-in-new-tab actions and the explicit static fallback.
       Ordinary checkout clicks rebuild the item URL from the live cart. */
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    event.preventDefault();
    event.stopPropagation();
    goCheckout(href);
  }, true);

  /* Forms that submit the cart to checkout (Enter key, theme scripts, apps). */
  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute("action") || "";
    var submitter = event.submitter;
    var isCheckout = /\/checkout/.test(action) || (submitter && submitter.getAttribute("name") === "checkout") ||
      (/\/cart\/?$/.test(action) && form.querySelector('[name="checkout"]'));
    if (!isCheckout) return;
    event.preventDefault();
    event.stopPropagation();
    goCheckout();
  }, true);

  /* Rede de segurança: qualquer link para a loja de checkout sai com os
     parâmetros de campanha, mesmo se criado por outro trecho do tema. */
  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var anchor = target.closest('a[href*="' + CHECKOUT_DOMAIN + '"]');
    if (!anchor) return;
    anchor.setAttribute("rel", "noreferrer");
    anchor.setAttribute("referrerpolicy", "no-referrer");
    if (anchor.getAttribute("data-tcs-attr") === "1") return;
    anchor.setAttribute("href", decorate(anchor.getAttribute("href") || ""));
    anchor.setAttribute("data-tcs-attr", "1");
  }, true);

  /* ---- Barra "Cart reserved for MM:SS" no topo da gaveta/pagina de carrinho ---- */
  var RESERVED_KEY = "tcs_reserved_until";
  var RESERVED_MS = 5 * 60 * 1000;

  function reservedLeft() {
    var until = 0;
    try { until = parseInt(sessionStorage.getItem(RESERVED_KEY) || "0", 10); } catch (e) {}
    var left = until - Date.now();
    if (left <= 0) {
      until = Date.now() + RESERVED_MS;
      try { sessionStorage.setItem(RESERVED_KEY, String(until)); } catch (e) {}
      left = RESERVED_MS;
    }
    return left;
  }

  function tcsHeading() {
    var h = document.querySelector(".cart-drawer__heading");
    if (!h) return;
    var countEl = h.querySelector(".cart-bubble__text-count");
    var n = parseInt((countEl && countEl.textContent) || "0", 10) || 0;
    var label = "Cart \u2022 " + n + (n === 1 ? " item" : " items");
    var t = h.querySelector(".tcs-heading-text");
    if (!t) {
      t = document.createElement("span");
      t.className = "tcs-heading-text";
      for (var i = h.childNodes.length - 1; i >= 0; i--) {
        if (h.childNodes[i].nodeType === 3) h.removeChild(h.childNodes[i]);
      }
      h.insertBefore(t, h.firstChild);
    }
    if (t.textContent !== label) t.textContent = label;
  }

  function ensureReservedBar() {
    tcsHeading();
    var header = document.querySelector(".cart-drawer__header");
    var host = header ? header.parentNode : document.querySelector("main .cart, .cart-page, main");
    if (!host) return;
    if (host.querySelector(".tcs-reserved")) return;
    var bar = document.createElement("div");
    bar.className = "tcs-reserved";
    bar.innerHTML = 'Cart reserved for <span>05:00</span>';
    if (header) host.insertBefore(bar, header.nextSibling); else host.insertBefore(bar, host.firstChild);
    var span = bar.querySelector("span");
    var tick = function () {
      if (!document.body.contains(bar)) { window.clearInterval(iv); return; }
      var left = reservedLeft();
      var m = Math.floor(left / 60000);
      var sec = Math.floor((left % 60000) / 1000);
      span.textContent = (m < 10 ? "0" + m : m) + ":" + (sec < 10 ? "0" + sec : sec);
    };
    tick();
    var iv = window.setInterval(tick, 1000);
  }

  if (window.MutationObserver) {
    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(function () {
        scheduled = false;
        patchAll(document);
        decorateStaticLinks(document);
        ensureReservedBar();
      }, 250);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() { decorateStaticLinks(document); refresh(); ensureReservedBar(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
